/** Still portraits of a blob, for buttons, lists and cards. */
import type { Look } from '../../../shared/cosmetics.ts'
import type { Emote } from '../../../shared/protocol.ts'
import { blobArt, drawBlob } from '../render/blob.ts'

export function drawThumb(c: HTMLCanvasElement, look: Look, emote: Emote | 'idle' = 'idle', hat = true, t = 0): void {
  const px = c.clientWidth || Number(c.dataset.size) || 48
  const dpr = Math.min(2, window.devicePixelRatio || 1)
  const s = Math.round(px * dpr)
  if (c.width !== s) { c.width = s; c.height = s }
  const ctx = c.getContext('2d')!
  ctx.setTransform(1, 0, 0, 1, 0, 0)
  ctx.clearRect(0, 0, s, s)
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0)
  const hasHat = hat && look.hat !== 'none'
  // A blobatar body fills roughly the middle 60% of its 100-unit box; hats need ~35 more units above.
  const size = px * (hasHat ? 0.98 : 1.25)
  drawBlob(ctx, blobArt(look, emote), px / 2, px * (hasHat ? 0.97 : 0.93), { size, facing: 1, hat: hasHat ? look.hat : undefined, t })
}

export function thumb(look: Look, size: number, emote: Emote | 'idle' = 'idle', hat = true): HTMLCanvasElement {
  const c = document.createElement('canvas')
  c.dataset.size = String(size)
  c.style.width = `${size}px`
  c.style.height = `${size}px`
  drawThumb(c, look, emote, hat)
  return c
}
